import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { setIsActiveRightSidebar } from '../redux/dashboardActions';

import { useTypedSelector } from '../../../hooks/useTypedSelector';
import RightSideBarItens from './rightSideBarItens';

interface IAction {
  func: React.Dispatch<React.SetStateAction<boolean>>;
  value: boolean;
}

export interface IMenuItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  class: string;
  disabled: boolean;
  action: IAction;
  isVisible: boolean;
  activeState?: boolean;
  disabledAction?: (item: IMenuItem) => void;
}

interface IMenuRightSidebarProps {
  data: IMenuItem[];
}

export default function MenuRightSidebar({
  data,
}: IMenuRightSidebarProps): JSX.Element {
  const dispatch = useDispatch();
  const { menuAction } = useTypedSelector(
    (state) => state.dashboardState.isActiveRightSidebar
  );

  const actionMenu = (selectedItem: IMenuItem) => {
    selectedItem.action.func(!selectedItem.action.value);
    dispatch(
      setIsActiveRightSidebar({
        name: 'menuAction',
        value: menuAction === selectedItem.id ? '0' : selectedItem.id,
      })
    );
  };

  return (
    <div className="menu-map-sidebar-right">
      {data && data.length
        ? data.map((item) => {
            return (
              <RightSideBarItens
                key={crypto.randomUUID()}
                item={item}
                actionMenu={actionMenu}
              />
            );
          })
        : null}
    </div>
  );
}
